export function exclusiveRighttoSellListingContract2026CB() {
return [   // Release 2025-12-23 10:07:11
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Radiobutton BrokerRelationship Seller Agency", 
   isText: false,
   type: "checkbox",
   top: 276.219,
   left: 159.055,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Radiobutton BrokerRelationship Transaction Brokerage", 
   isText: false,
   type: "checkbox",
   top: 277.529,
   left: 282.11,
   width: 10.08,
   height: 10.080
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 297.36,
   left: 451.56,
   width: 120.00,
   height: 13.56
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 489.84,
   left: 113.88,
   width: 450.00,
   height: 13.56
}
,
{
   page: 0,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 525,
   left: 120,
   width: 447.24,
   height: 13.56
}
,
{
   page: 0,
   name: "Address County", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 542.52,
   left: 424.32,
   width: 142.80,
   height: 12.905
}
,
{
   page: 0,
   name: "Address Legal Description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 568.148,
   left: 48.4366,
   width: 530.2924,
   height: 182.3643
}
,
{
   page: 1,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 40.32,
   left: 102.84,
   width: 459.96,
   height: 12.36
}
,
{
   page: 1,
   name: "Checkbox isAffordableHousing", 
   isText: false,
   type: "checkbox",
   top: 92.76,
   left: 81.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Lease of Property", 
   isText: false,
   type: "checkbox",
   top: 179.4,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Date Listing Ends", 
   fontSize: 9,
   type: "date",
   top: 251.625,
   left: 68.7276,
   width: 53.7814,
   height: 11.705
}
,
{
   page: 1,
   name: "Date Listing Begins", 
   fontSize: 9,
   type: "date",
   top: 224.88,
   left: 388.92,
   width: 180.00,
   height: 12.36
}
,
{
   page: 1,
   name: "TextDate Listing Ends", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 251.625,
   left: 124.211,
   width: 333.709,
   height: 11.705
}
,
{
   page: 1,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will", 
   isText: false,
   type: "checkbox",
   top: 393.48,
   left: 322.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will Not", 
   isText: false,
   type: "checkbox",
   top: 393.48,
   left: 374.52,
   width: 10.735,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Seller Agency Only", 
   isText: false,
   type: "checkbox",
   top: 619.203,
   left: 118.473,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Radiobutton ConsentDisclosureOfOffers Does", 
   isText: false,
   type: "checkbox",
   top: 348.84,
   left: 114.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton ConsentDisclosureOfOffers Does Not", 
   isText: false,
   type: "checkbox",
   top: 348.84,
   left: 170.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Sale Compensation Percent", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 529.92,
   left: 191.76,
   width: 49.92,
   height: 12.36
}
,
{
   page: 2,
   name: "Sale Compensation Dollars", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 529.92,
   left: 445.44,
   width: 99.96,
   height: 12.36
}
,
{
   page: 2,
   name: "of the gross purchase price or 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 679.68,
   left: 226.32,
   width: 45.00,
   height: 12.36
}
,
{
   page: 2,
   name: "in US dollars", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 679.68,
   left: 424.08,
   width: 84.96,
   height: 12.36
}
,
{
   page: 3,
   name: "Percent Lease Compensation", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 42,
   left: 504.96,
   width: 55.08,
   height: 10.68
}
,
{
   page: 3,
   name: "Amount Lease Compensation", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 53.52,
   left: 224.76,
   width: 65.04,
   height: 10.68
}
,
{
   page: 3,
   name: "of the gross purchase price or 2_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 122.64,
   left: 298.08,
   width: 45.00,
   height: 10.68
}
,
{
   page: 3,
   name: "in", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 122.64,
   left: 498.84,
   width: 65.04,
   height: 10.68
}
,
{
   page: 3,
   name: "Other Compensation", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 206.184,
   left: 61.8551,
   width: 513.2759,
   height: 33.782
}
,
{
   page: 3,
   name: "Number Holdover Days", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 291.36,
   left: 369.12,
   width: 44.04,
   height: 10.68
}
,
{
   page: 3,
   name: "Radiobutton SubmitToMLS Will", 
   isText: false,
   type: "checkbox",
   top: 554.76,
   left: 162.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton SubmitToMLS Will Not", 
   isText: false,
   type: "checkbox",
   top: 554.76,
   left: 212.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton SubmitPropertyInfoExchanges Will", 
   isText: false,
   type: "checkbox",
   top: 570.36,
   left: 162.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton SubmitPropertyInfoExchanges Will Not", 
   isText: false,
   type: "checkbox",
   top: 570.36,
   left: 212.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Marketing Exceptions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 649.966,
   left: 57.6003,
   width: 519.1647,
   height: 100.5463
}
,
{
   page: 4,
   name: "Radiobutton DisplayAddressOnInternet Will", 
   isText: false,
   type: "checkbox",
   top: 58.2,
   left: 198.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Radiobutton DisplayAddressOnInternet Will Not", 
   isText: false,
   type: "checkbox",
   top: 58.2,
   left: 252.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Radiobutton DisplayListingOnInternet Will", 
   isText: false,
   type: "checkbox",
   top: 75.24,
   left: 198.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Radiobutton DisplayListingOnInternet Will Not", 
   isText: false,
   type: "checkbox",
   top: 75.24,
   left: 252.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Checkbox PropertyAccess Electronic Lock Box", 
   isText: false,
   type: "checkbox",
   top: 115.32,
   left: 104.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Checkbox PropertyAccess Manual Lock Box", 
   isText: false,
   type: "checkbox",
   top: 132.12,
   left: 104.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Checkbox PropertyAccess Other", 
   isText: false,
   type: "checkbox",
   top: 149.892,
   left: 104.728,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "PropertyAccess Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 144.84,
   left: 122.4,
   width: 444.96,
   height: 14.16
}
,
{
   page: 4,
   name: "PropertyAccess Other Instructions 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 161.76,
   left: 155.28,
   width: 411.96,
   height: 14.16
}
,
{
   page: 4,
   name: "PropertyAccess Other Instructions 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 176.64,
   left: 67.8435,
   width: 499.3965,
   height: 14.815
}
,
{
   page: 4,
   name: "Checkbox AuthorizedAccess Actively Licensed Real Estate Brokers", 
   isText: false,
   type: "checkbox",
   top: 227.64,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Checkbox AuthorizedAccess Licensed Appraisers", 
   isText: false,
   type: "checkbox",
   top: 227.64,
   left: 316.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Checkbox AuthorizedAccess Unlicensed Broker Assistants", 
   isText: false,
   type: "checkbox",
   top: 244.44,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Checkbox AuthorizedAccess Unlicensed Inspectors", 
   isText: false,
   type: "checkbox",
   top: 244.44,
   left: 316.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Checkbox AuthorizedAccess Other", 
   isText: false,
   type: "checkbox",
   top: 261.24,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "AuthorizedAccess Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 256.92,
   left: 152.16,
   width: 415.32,
   height: 14.16
}
,
{
   page: 4,
   name: "Broker Marketing", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 346.565,
   left: 58.9093,
   width: 511.9657,
   height: 128.692
}
,
{
   page: 4,
   name: "Media Recording Exceptions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 497.457,
   left: 55.6366,
   width: 515.8924,
   height: 58.000
}
,
{
   page: 4,
   name: "Radiobutton AgreementWithOtherBroker Is", 
   isText: false,
   type: "checkbox",
   top: 706.44,
   left: 351.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Radiobutton AgreementWithOtherBroker Is Not", 
   isText: false,
   type: "checkbox",
   top: 706.44,
   left: 393.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Radiobutton ReceivedListOfSubmittedProperty Has", 
   isText: false,
   type: "checkbox",
   top: 719.64,
   left: 425.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Radiobutton ReceivedListOfSubmittedProperty Has Not", 
   isText: false,
   type: "checkbox",
   top: 719.64,
   left: 472.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Amount Listing Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 223.96,
   left: 137.64,
   width: 129.96,
   height: 12.84
}
,
{
   page: 5,
   name: "Checkbox Group Loan Cash", 
   isText: false,
   type: "checkbox",
   top: 241.56,
   left: 117.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Group Loan Conventional", 
   isText: false,
   type: "checkbox",
   top: 241.56,
   left: 170.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Group Loan FHA", 
   isText: false,
   type: "checkbox",
   top: 241.56,
   left: 254.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Group Loan VA", 
   isText: false,
   type: "checkbox",
   top: 241.56,
   left: 299.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Group Loan Other", 
   isText: false,
   type: "checkbox",
   top: 241.56,
   left: 340.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Group Loan Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 238.68,
   left: 392.88,
   width: 174.36,
   height: 12.84
}
,
{
   page: 5,
   name: "Loan Discount Points", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 254.76,
   left: 180.48,
   width: 386.76,
   height: 12.84
}
,
{
   page: 5,
   name: "Amount Max FHA Closing Costs", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 270.6,
   left: 446.88,
   width: 89.64,
   height: 12.84
}
,
{
   page: 5,
   name: "Buyer is not allowed by law to pay for tax service and", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 285.72,
   left: 278.16,
   width: 288.96,
   height: 12.84
}
,
{
   page: 5,
   name: "Amount Earnest Money Minimum", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 301.44,
   left: 340.8,
   width: 84.12,
   height: 12.84
}
,
{
   page: 5,
   name: "Earnest Money Form", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 316.32,
   left: 158.28,
   width: 409.20,
   height: 12.84
}
,
{
   page: 5,
   name: "Radiobutton SellerProceeds Cashiers Check", 
   isText: false,
   type: "checkbox",
   top: 351.24,
   left: 59.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Radiobutton SellerProceeds Wire Transfer", 
   isText: false,
   type: "checkbox",
   top: 367.32,
   left: 59.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Radiobutton SellerProceeds Closing Company Check", 
   isText: false,
   type: "checkbox",
   top: 383.16,
   left: 59.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox IS a foreign person", 
   isText: false,
   type: "checkbox",
   top: 424.68,
   left: 259.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Number of Remote Controls", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 613.68,
   left: 341.16,
   width: 110.04,
   height: 12.36
}
,
{
   page: 5,
   name: "Checkbox Inclusions None", 
   isText: false,
   type: "checkbox",
   top: 643.8,
   left: 63.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Inclusions Solar Panels", 
   isText: false,
   type: "checkbox",
   top: 643.8,
   left: 111.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Inclusions Water Softeners", 
   isText: false,
   type: "checkbox",
   top: 643.8,
   left: 185.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Inclusions Security Systems", 
   isText: false,
   type: "checkbox",
   top: 643.8,
   left: 279.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Inclusions Satellite Systems", 
   isText: false,
   type: "checkbox",
   top: 643.8,
   left: 376.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Inclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 63.927,
   left: 52.3095,
   width: 523.0925,
   height: 101.855
}
,
{
   page: 6,
   name: "Encumbered Inclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 201.382,
   left: 52.964,
   width: 522.438,
   height: 49.491
}
,
{
   page: 6,
   name: "ChecklistItem Leased Items", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 301.183,
   left: 65.4004,
   width: 509.3466,
   height: 52.764
}
,
{
   page: 6,
   name: "Exclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 400.056,
   left: 51.6552,
   width: 519.1648,
   height: 90.073
}
,
{
   page: 6,
   name: "Trade Fixtures", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 492.72,
   left: 326.16,
   width: 240.96,
   height: 12.48
}
,
{
   page: 6,
   name: "Trade Fixtures Liens", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 519.36,
   left: 305.28,
   width: 261.84,
   height: 12.48
}
,
{
   page: 6,
   name: "Parking", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 561,
   left: 58.68,
   width: 509.52,
   height: 12.48
}
,
{
   page: 6,
   name: "Storage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 588.36,
   left: 58.68,
   width: 509.88,
   height: 12.48
}
,
{
   page: 6,
   name: "Checkbox WaterRights Deeded Water Rights", 
   isText: false,
   type: "checkbox",
   top: 621.72,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "WaterRights Deeded Water Rights", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 632.403,
   left: 63.4003,
   width: 508.0387,
   height: 92.0361
}
,
{
   page: 6,
   name: "WaterRights Deed at Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 725.52,
   left: 348.72,
   width: 155.64,
   height: 12.48
}
,
{
   page: 7,
   name: "WaterRights Well Permit Number", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 29.96,
   left: 372.0,
   width: 195.12,
   height: 12.84
}
,
{
   page: 7,
   name: "Checkbox WaterRights Well Rights", 
   isText: false,
   type: "checkbox",
   top: 32.84,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Checkbox WaterRights Water Stock", 
   isText: false,
   type: "checkbox",
   top: 48.68,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "WaterRights Water Stock", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 59.819,
   left: 61.1461,
   width: 508.0389,
   height: 47.527
}
,
{
   page: 7,
   name: "Checkbox WaterRights Other", 
   isText: false,
   type: "checkbox",
   top: 107.96,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "WaterRights Other", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 132.91,
   left: 59.1825,
   width: 510.6565,
   height: 47.528
}
,
{
   page: 7,
   name: "Growing Crops", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 192.256,
   left: 52.637,
   width: 516.548,
   height: 46.218
}
,
{
   page: 7,
   name: "Radiobutton DeedType Special Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 317.96,
   left: 59.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton DeedType General Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 317.96,
   left: 212.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton DeedType Bargain And Sale Deed", 
   isText: false,
   type: "checkbox",
   top: 317.96,
   left: 413.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton DeedType Quit Claim Deed", 
   isText: false,
   type: "checkbox",
   top: 332.84,
   left: 59.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton DeedType Personal Representatives Deed", 
   isText: false,
   type: "checkbox",
   top: 332.84,
   left: 212.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton DeedType Other", 
   isText: false,
   type: "checkbox",
   top: 347.383,
   left: 59.5639,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 7,
   name: "DeedType Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 344.72,
   left: 77.76,
   width: 465.00,
   height: 12.84
}
,
{
   page: 7,
   name: "Monetary Encumbrances", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 443.402,
   left: 53.0184,
   width: 510.6566,
   height: 12.182
}
,
{
   page: 7,
   name: "ChecklistItem Tenancies", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 492.22,
   left: 53.673,
   width: 518.511,
   height: 39.019
}
,
{
   page: 7,
   name: "RadioButton LocatedInOwersAssociation Is", 
   isText: false,
   type: "checkbox",
   top: 598.92,
   left: 345.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "RadioButton LocatedInOwersAssociation Is Not", 
   isText: false,
   type: "checkbox",
   top: 598.92,
   left: 384.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Amount Association Assessment", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 634.56,
   left: 169.92,
   width: 114.96,
   height: 12.84
}
,
{
   page: 7,
   name: "Frequency Association Assessment", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 634.56,
   left: 302.64,
   width: 249.96,
   height: 12.84
}
,
{
   page: 7,
   name: "Special Assessments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 664.32,
   left: 58.8,
   width: 510.0,
   height: 12.84
}
,
{
   page: 8,
   name: "Possession", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 60,
   left: 49.68,
   width: 519.96,
   height: 12.36
}
,
{
   page: 8,
   name: "Radiobutton SellerProvidesSPD Agrees", 
   isText: false,
   type: "checkbox",
   top: 205.08,
   left: 291.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Radiobutton SellerProvidesSPD Does Not Agree", 
   isText: false,
   type: "checkbox",
   top: 205.08,
   left: 352.2,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Radiobutton ForfeitureOfPayments Paid To Seller", 
   isText: false,
   type: "checkbox",
   top: 653.64,
   left: 82.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Radiobutton ForfeitureOfPayments Split Seller And Brokerage Firm", 
   isText: false,
   type: "checkbox",
   top: 669,
   left: 82.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Radiobutton ForfeitureOfPayments Other", 
   isText: false,
   type: "checkbox",
   top: 697.32,
   left: 82.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "ForfeitureOfPayments Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 694.92,
   left: 128.16,
   width: 438.96,
   height: 12.36
}
,
{
   page: 10,
   name: "Additional Provisions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 32.727,
   left: 37.9638,
   width: 536.8382,
   height: 456.620
}
,
{
   page: 10,
   name: "Attachments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 502.039,
   left: 43.2002,
   width: 531.6018,
   height: 90.073
}
,
{
   page: 10,
   name: "Electronic Notice", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 692.88,
   left: 285.84,
   width: 276.72,
   height: 10.80
}
,
{
   page: 11,
   name: "Seller 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 472.98,
   left: 107.457,
   width: 469.680,
   height: 14.16
}
,
{
   page: 11,
   name: "Seller 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 430.98,
   left: 107.457,
   width: 469.680,
   height: 14.16
}
,
{
   page: 11,
   name: "Seller 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 408.06,
   left: 116.097,
   width: 465.000,
   height: 14.04
}
,
{
   page: 11,
   name: "Seller 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 393.06,
   left: 116.097,
   width: 170.040,
   height: 14.16
}
,
{
   page: 11,
   name: "Seller 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 393.511,
   left: 410.588,
   width: 169.920,
   height: 14.160
}
,
{
   page: 11,
   name: "Seller 2 Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 378.06,
   left: 116.097,
   width: 465.000,
   height: 14.04
}
,
{
   page: 11,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 340.02,
   left: 107.457,
   width: 469.680,
   height: 14.16
}
,
{
   page: 11,
   name: "Seller 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 317.1,
   left: 116.097,
   width: 465.000,
   height: 14.04
}
,
{
   page: 11,
   name: "Seller 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 302.1,
   left: 116.097,
   width: 170.040,
   height: 14.16
}
,
{
   page: 11,
   name: "Seller 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 302.551,
   left: 410.588,
   width: 169.920,
   height: 14.160
}
,
{
   page: 11,
   name: "Seller 1 Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 287.22,
   left: 116.097,
   width: 465.000,
   height: 14.16
}
,
{
   page: 11,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 249.366,
   left: 105.013,
   width: 469.680,
   height: 14.160
}
,
{
   page: 11,
   name: "Seller Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 517.857,
   left: 117.316,
   width: 349.920,
   height: 12.720
}
,
{
   page: 11,
   name: "Seller Broker Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 533.991,
   left: 117.316,
   width: 349.920,
   height: 12.720
}
,
{
   page: 11,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 550.475,
   left: 122.091,
   width: 343.092,
   height: 15.454
}
,
{
   page: 11,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 572.391,
   left: 69.7964,
   width: 174.9596,
   height: 12.720
}
,
{
   page: 11,
   name: "Seller Brokerage Firm Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 601.191,
   left: 182.716,
   width: 349.920,
   height: 12.720
}
,
{
   page: 11,
   name: "Seller Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 614.631,
   left: 182.716,
   width: 349.920,
   height: 12.720
}
,
{
   page: 11,
   name: "Seller Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 628.071,
   left: 182.716,
   width: 349.920,
   height: 12.720
}
,
{
   page: 11,
   name: "Seller Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 641.511,
   left: 182.716,
   width: 349.920,
   height: 12.720
}
,
{
   page: 11,
   name: "Seller Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 655.191,
   left: 182.716,
   width: 349.920,
   height: 12.720
}
,
{
   page: 11,
   name: "Seller CoAgent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 690.231,
   left: 132.316,
   width: 349.920,
   height: 12.7202
}
,
{
   page: 11,
   name: "Signature Seller CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 706.9122,
   left: 136.8,
   width: 343.092,
   height: 14.8000
}
,
{
   page: 11,
   name: "Date Signature Seller CoAgent", 
   fontSize: 9,
   type: "date",
   top: 728.6312,
   left: 69.7964,
   width: 174.9596,
   height: 12.7200
}
] }
